import Vue from 'vue'
import VueGmaps from 'vue-gmaps'


Vue.use(VueGmaps, {
  key: 'AIzaSyDhyuzW32WIEYtnmA3vdiGfTjQjZ_DyGlU',
  loadGoogleApi: false
})
